import React from 'react';
import { Trans } from '@lingui/react';
import { FormattedCurrency } from '@qover/react-intl';

export default {
  discount: (discount: number) => (
    <Trans id="bike.quote.discount" values={{ discount }} />
  ),
  discountPrice: (discount: number) => (
    <Trans
      id="bike.quote.discountPrice"
      values={{ discount: <FormattedCurrency value={discount} /> }}
    />
  ),
  price: (price: number) => (
    <Trans
      id="bike.quote.price"
      values={{ price: <FormattedCurrency value={price} /> }}
    />
  ),
  description: <Trans id="bike.quote.description" />,
  recurringDescription: <Trans id="bike.quote.recurringDescription" />,
  actionLabel: <Trans id="bike.quote.actionLabel" />,
};
